import { getBackendURL } from "../getBaseUrl";
import {
  EventSchema,
  type EventSubscription,
  type EventSubscriptionOptions,
  type EventsParams,
} from "./eventsClient.types";
import { subscribeToSSE } from "./sse";

// Every tab holds one of these open, so the stream stops after five consecutive
// failures rather than adding to a reconnect storm the backend is already
// struggling under.
const MAX_RECONNECT_ATTEMPTS = 5;

export function subscribeToEvents(params: EventsParams, options: EventSubscriptionOptions): EventSubscription {
  return subscribeToSSE({
    url: `${getBackendURL()}/events`,
    maxAttempts: MAX_RECONNECT_ATTEMPTS,
    buildHeaders: () => {
      const headers: Record<string, string> = { "X-Project-Id": params.projectId };
      const token = options.authToken();
      if (token) {
        headers.Authorization = `Bearer ${token}`;
      }
      return headers;
    },
    onData: (data) => {
      try {
        const result = EventSchema.safeParse(JSON.parse(atob(data)));
        if (!result.success) {
          options.onError?.(new Error(`Failed to parse event: ${result.error.message}`));
          return;
        }
        options.onEvent(result.data);
      } catch (error) {
        options.onError?.(error instanceof Error ? error : new Error("Failed to process event"));
      }
    },
    onError: options.onError,
    onConnect: options.onConnect,
    onDisconnect: options.onDisconnect,
  });
}
